import types from 'constants/actionTypes';
import { createThunk } from 'utils/createThunk';
import * as backendAPI from 'api/backendAPI/series';

export const setSelectedSeriesId = seriesId => ({
  type: types.SET_SELECTED_SERIES_ID,
  payload: seriesId,
});

export const fetchSeriesPipeline = createThunk({
  apiCall: backendAPI.getSeriesPipelineData,
  type: types.GET_SERIES_PIPELINE_REQUEST,
});
